import React from 'react';
import Raven from 'raven-js';
import OldBrowser from './browser';
import PropTypes from 'prop-types';
import request from '../../request';
import Input from '../shared/input';
import { Link } from 'react-router-dom';
import Submit from '../shared/submit';

export default class Login extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor() {
    super();

    this.state = { old: OldBrowser };
  }

  componentWillMount() {
    localStorage.clear();
  }

  async login() {
    let { email, password } = this.state;

    try {
      this.setState({ loading: true });
      let { token, id, type, reset_token, ...data } = await request({
        url: 'auth/login',
        body: { email, password },
      });

      if (reset_token)
        return this.context.router.history.push(
          `/auth/finish/${encodeURIComponent(reset_token)}/${encodeURIComponent(
            data.email
          )}?message=Your password must be changed before you can login.`
        );
      Raven.setUserContext({
        email,
        id,
        system: process.env.REACT_APP_API_URL,
      });
      localStorage.setItem('token', token);
      localStorage.setItem('user_id', id);
      localStorage.setItem('type', type);
      this.context.router.history.push('/');
    } catch (error) {
      this.setState({ error, loading: false });
    }
  }

  render() {
    let { error, loading, old } = this.state;

    if (old)
      return (
        <div id="main">
          <p className="fail">
            Your browser is unsupported. Please use Chrome &gt; 19, Safari &gt;
            5, Firefox &gt; 19, or IE 11 / Edge.
          </p>
        </div>
      );
    return process.env.REACT_APP_DISABLE_LOGIN ? (
      <div id="main">
        <p className="fail">Access is currently disabled.</p>
      </div>
    ) : (
      <div id="main" style={{ opacity: loading ? 0.5 : 1 }}>
        {error ? <p className="fail">{error.message || error}</p> : null}
        <Input
          name="email"
          placeholder="Email address"
          onChange={email => this.setState({ email })}
        />
        <Input
          name="password"
          type="password"
          className="password"
          placeholder="Password"
          onChange={password => this.setState({ password })}
          onEnter={() => this.login()}
        />
        <Submit onClick={() => this.login()} id="send" />
        <p id="options">
          <Link to="/auth/forgot/">Forgot password?</Link>
        </p>
        <p id="notice">
          Please note: All access to this system is recorded and monitored.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/login.js